import { render, staticRenderFns } from "./price.vue?vue&type=template&id=5bf33459&"
import script from "./price.vue?vue&type=script&lang=js&"
export * from "./price.vue?vue&type=script&lang=js&"
import style0 from "./price.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bf33459')) {
      api.createRecord('5bf33459', component.options)
    } else {
      api.reload('5bf33459', component.options)
    }
    module.hot.accept("./price.vue?vue&type=template&id=5bf33459&", function () {
      api.rerender('5bf33459', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/field-template/price.vue"
export default component.exports